import styled, { css } from 'styled-components';

import { hexToRgba } from '~/common/utils/hex-to-rgba';
import { SPACING } from '~/common/constants/spacing';
import { RADIUS } from '~/common/constants/radius';

interface IButtonContainerProps {
  width: string;
  backgroundColor: string;
  textColor: string;
  textOrIconColorOnHover: string;
  borderColor: string;
  disabled: boolean;
  customCssBorderHover: string;
  hoverBackgroundColor: string;
  justifyContent: string;
  height: string;
  circular: boolean;
  containerPadding: number;
  boxShadow: string;
}

export const ButtonContainer = styled.button<IButtonContainerProps>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  max-height: ${({ height }) => height} !important;
  border: 1px solid ${({ borderColor }) => borderColor};
  background-color: ${({ backgroundColor }) => backgroundColor};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'all')};
  cursor: pointer;
  padding: ${({ containerPadding }) => `${containerPadding}px`};
  overflow: hidden;
  border-radius: ${({ circular }) => (circular ? '999px' : RADIUS._8)};
  display: flex;
  flex-direction: row;
  justify-content: ${({ justifyContent }) => justifyContent};
  align-items: center;
  gap: ${SPACING._12};
  user-select: none;
  transition: 200ms;

  outline: 1px ${({ backgroundColor }) => hexToRgba(backgroundColor, 0.5)} solid;
  outline-offset: -1px;
  position: relative; /* Necessário para os pseudo-elementos */

  ${({ boxShadow }) =>
    boxShadow &&
    css`
      box-shadow: ${boxShadow};
    `}

  &:hover {
    ${({ boxShadow }) =>
      !boxShadow &&
      css`
        box-shadow: 0px 0px 0px 4px rgba(153, 160, 174, 0.16);
      `}

    ${({ hoverBackgroundColor }) =>
      hoverBackgroundColor &&
      css`
        background-color: ${hoverBackgroundColor};
      `}
  }

  div,
  span,
  svg {
    position: relative;
    z-index: 2; /* Mantém o conteúdo acima de todas as camadas */
  }

  #arrow {
    img {
      transition: 200ms;
    }
  }

  span {
    white-space: nowrap;
    transition: 200ms;
    color: ${({ textColor }) => textColor};
  }

  svg {
    transition: 200ms;
  }

  ${({ disabled, backgroundColor }) =>
    disabled &&
    css`
      background-color: ${hexToRgba(backgroundColor, 0.5)};
    `}
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
